export default __webpack_public_path__ + "static/media/01.d782a58c.jpg";